// Libraries
import _ from 'lodash';

import {pluralize} from '@supermove/utils';

const Distance = {
  display: (distance: number) => {
    return pluralize('mile', _.round(distance, 1), true);
  },

  shortDisplay: (distance: number) => {
    return `${_.round(distance, 1)} mi`;
  },
};

export default Distance;
